import React, { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import VipExisting from '../../organisms/VipExisting/VipExisting'

// Only existing VIP processes can be opened. New VIP nominations are retired;
// without an id the user is sent to the VipRetired info page at /vip.
const VipProcess = ({ setTitle }) => {
    const { id } = useParams()

    useEffect(() => {
        setTitle('VIP - Value In People')
    }, [])

    return (
        id ?
            <VipExisting id={id} />
            :
            <Navigate to='/vip' replace />
    )
}

export default VipProcess
